import { createContext } from 'react';
/**
 * React context for managing loading states across the application.
 * Provides access to loading flags and their setter functions through
 * the React Context API.
 * @public
 */
export const LoadingStateContext = createContext({
  loadingStatusMessages: [],
  setLoadingStatusMessage: null
});